import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { environment } from '../environment/environment';
import { IJoinMeeting } from '../models/IJoinMeeting';

class JoinMeetingService {
  private static instance: JoinMeetingService;

  private constructor() {}

  public static getInstance(): JoinMeetingService {
    if (!JoinMeetingService.instance) {
      JoinMeetingService.instance = new JoinMeetingService();
    }
    return JoinMeetingService.instance;
  }

  public createTokenForNewParticipant = async (participantDetail: IJoinMeeting): Promise<{ token: string }> => {
    try {
      const axiosConfig: AxiosRequestConfig = {
        headers: {
          'TenantAlias': environment.tenantAlias,
        },
      };
      const response: AxiosResponse<{ token: string }> = await axios.post(
        `${environment.controlServerEndpoint}/session/${participantDetail.pid}/participant/token`,
        participantDetail,
        axiosConfig
      );
  
      // Extract the token from the response data
      return response.data;
    } catch (error) {
      console.error('Error creating token for participant:', error);
      throw error;
    }
  };
  
}

export default JoinMeetingService.getInstance();
